export class ProductUtils {
  ACCOUNT: boolean = false;
  ELIGIBILITY: boolean= false;
  NEP_TEMPLATE: boolean= false;
  MEMO: boolean= false;
  LAS: boolean= false;
  OFFER_LETTER: boolean= false;
  DMS: boolean= false;
  nepTemplate: boolean= false;
  LOAN_APPROVAL_HIERARCHY_LEVEL: string | undefined;
  CAD_LITE_VERSION: boolean= false;
  CBS_ENABLE: boolean= false;
  FULL_CAD: boolean= false;
  CHECK_LIST_LITE_VERSION: boolean= false;
  CUSTOMER_BASE_LOAN: boolean= false;
  CONFIGURE_LEGAL_DOCUMENT: boolean= false;

}
